import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Output } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { BusinessService } from '../../services/business.service';
import { ModalComponent } from '../modal/modal.component';
import { ButtonComponent } from '../../utilities/button/button.component';
import { InputComponent } from '../../utilities/input/input.component';
import { TextAreaComponent } from '../../utilities/text-area/text-area.component';
import { AvatarComponent } from '../avatar/avatar.component';
import { NzNotificationService } from 'ng-zorro-antd/notification';
import { GeneralService } from '../../services/general.service';
import { AuthService } from '../../services/auth.service';

@Component({
  selector: 'app-navbar',
  standalone: true,
  imports: [
    CommonModule,
    ModalComponent,
    ButtonComponent,
    InputComponent,
    TextAreaComponent,
    AvatarComponent,
  ],
  templateUrl: './navbar.component.html',
  styleUrl: './navbar.component.scss',
})
export class NavbarComponent {
  currentRoute: string = '';
  navOpen: boolean = false;
  isMobileSideNav: boolean = false;
  @Output() openMobileSideNav = new EventEmitter<boolean>();
  businesses: any;
  fetchingData: boolean = false;
  details: any;
  newBusinessModalOpen: boolean = false;
  loading: boolean = false;
  activeBusiness: any;
  activeBusinessId: string = '';
  newBusiness: any = {
    name: '',
    description: '',
    emailAddress: '',
    address: '',
    city: '',
    state: '',
    country: '',
    postalCode: '',
  };
  errors: any = {
    name: '',
    description: '',
    emailAddress: '',
    address: '',
    city: '',
    state: '',
    country: '',
    postalCode: '',
  };

  constructor(
    private router: Router,
    private businessService: BusinessService,
    private notification: NzNotificationService,
    private generalService: GeneralService,
    private authService: AuthService
  ) {
    // this.addBusiness();
    // this.getBusinesses();
    this.getDetails();
  }
  ngOnInit() {
    this.router.events.subscribe((event) => {
      if (event instanceof NavigationEnd) {
        this.currentRoute = this.stripLeadingSlash(event.urlAfterRedirects);
      }
    });
    this.currentRoute = this.stripLeadingSlash(this.router.url);
  }
  stripLeadingSlash(route: string): string {
    const segments = route.split('/'); // Split the string by slashes
    return segments[1] || ''; // Return the second segment (after the base URL)
  }
  // getObjectById<T>(array: T[], id: string, idKey: keyof T): T | undefined {
  //   return array.find((item) => item[idKey] === id);
  // }
  mobileSideNavOpen = () => {
    this.isMobileSideNav = !this.isMobileSideNav;
    this.openMobileSideNav.emit(this.isMobileSideNav);
    console.log('navbar', this.isMobileSideNav);
  };
  openNewBusinessModal() {
    this.newBusinessModalOpen = true;
    this.navOpen = false;
  }
  closeNewBusinessModal() {
    this.newBusinessModalOpen = false;
  }
  openNav = () => {
    this.navOpen = !this.navOpen;
  };
  handleInput(data: { title: string; value: string }) {
    this.newBusiness[data.title] = data.value;
    if (data.value === '') {
      this.errors[data.title] = 'Required*';
      return;
    } else {
      this.errors[data.title] = '';
    }
  }
  setEmail = (data: { title: string; value: string }) => {
    this.newBusiness[data.title] = data.value;
    if (data.value === '') {
      this.errors[data.title] = 'Required*';
    } else if (!this.validateEmail(data.value)) {
      this.errors[data.title] = 'Please use a valid email*';
    } else {
      this.errors[data.title] = '';
    }
  };
  validateEmail = (email: string) => {
    return String(email)
      .toLowerCase()
      .match(
        /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
      );
  };
  validateForm = () => {
    const errors: any = {};
    if (this.newBusiness.name === '') {
      errors.name = 'Required*';
    }
    if (this.newBusiness.emailAddress === '') {
      errors.emailAddress = 'Required*';
    }
    if (this.newBusiness.address === '') {
      errors.address = 'Required*';
    }
    if (this.newBusiness.city === '') {
      errors.city = 'Required*';
    }
    if (this.newBusiness.state === '') {
      errors.state = 'Required*';
    }
    if (this.newBusiness.country === '') {
      errors.country = 'Required*';
    }
    if (this.newBusiness.description === '') {
      errors.description = 'Required*';
    }
    if (this.newBusiness.postalCode === '') {
      errors.postalCode = 'Required*';
    }
    if (this.newBusiness.emailAddress === '') {
      errors.emailAddress = 'Required*';
    } else if (!this.validateEmail(this.newBusiness.emailAddress)) {
      errors.emailAddress = 'Please use a valid email*';
    }
    // console.log(errors);
    return errors;
  };
  getBusinesses() {
    this.businessService.getBusinesses().subscribe({
      next: (res: any) => {
        // console.log(res);
        this.businesses = res.data;
        this.activeBusiness = res.data[0].business;
        localStorage.setItem(
          'activeBusinessName',
          String(this.activeBusiness?.name)
        );
      },
      error: (err) => {
        this.notification.error('Error', 'Failed to get business list', {
          nzClass: 'notification',
        });
      },
    });
  }
  getDetails(){
    this.fetchingData = true;
    this.authService.me().subscribe({
      next: (res: any) => {
        this.details = res;
        console.log(this.details);
        this.fetchingData = false
      },
      error: (err) => {
        this.notification.error('Error', 'Failed to get user data', {
          nzClass: 'notification',
        });
        this.fetchingData = false;
      },
    });
  }
  addBusiness() {
    const newBusiness = {
      name: "Acme Corporation",
    registrationCountry: "United States",
    address: {
      street: "123 Main Street",
      city: "New York",
      state: "NY",
      country: "United States"
    },
    emailAddress: "contact@acme.com",
    phoneNumber: "+1234567890",
    websiteUrl: "https://www.acme.com"
    }
    // if (Object.keys(this.validateForm()).length > 0) {
    //   this.errors = { ...this.errors, ...this.validateForm() };
    // } else {
      this.loading = true;
      this.businessService.addBusiness(newBusiness).subscribe({
        next: (res: any) => {
          // this.getBusinesses();
          console.log(res);
          this.loading = false;
          // this.newBusinessModalOpen = false;
          this.notification.success('Success', 'Business added successfully', {
            nzClass: 'notification',
          });
        },
        error: (err) => {
          this.loading = false;
          this.notification.error('Error', 'Failed to add business', {
            nzClass: 'notification',
          });
        },
      });
    // }
  }
  logout() {
    this.generalService.logoutUser();
  }
  switchBusiness(id: string) {
    this.businessService.switchBusiness(id).subscribe({
      next: (res: any) => {
        this.generalService.setToken(res.data.jwtToken);
        console.log(res);
        this.activeBusiness = res.data.membership.business;
        this.navOpen = false;
        this.getDetails();
      },
      error: (err) => {
        this.notification.error('Error', 'Failed to switch business', {
          nzClass: 'notification',
        });
      },
    });
  }
}
